import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { RECOMMENDED_IN_SUBCATEGORY } from '../../utils/carousels';

export const SOURCE = 'recommended_in_sc';
export const PRO_SOURCE = 'recommended_in_pro_sc';

class RecommendedInSc extends Component {

    constructor() {
        super();

        this.getSource = this.getSource.bind(this);
    }

    getSource() {
        const { general } = this.context;

        return general.isPro ? PRO_SOURCE : SOURCE;
    }

    render() {
        const { collections, updateCollections, isTouch, isLoggedIn } = this.props;
        const { general, pathfinderWrapper, requestContext } = this.context;
        const { gigId, isPro } = general;
        const { ref } = requestContext.params;

        const url = pathfinderWrapper.pathfinder('gig_page_fetch_recommendations_by_type',
            {type: 'by_gig_views'},
            {query: {gig_id: gigId, pro_only: isPro.toString(), ref}});

        return (
            <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.people_also_viewed.title"/>}
                boxClass="gigs-recommended-in"
                boxLocation="bottom"
                carouselPosition={3}
                collections={collections}
                isLoggedIn={isLoggedIn}
                isTouch={isTouch}
                updateCollections={updateCollections}
                type={RECOMMENDED_IN_SUBCATEGORY}
                url={url}
                source={this.getSource()}/>
        );
    }
}

RecommendedInSc.propTypes = {
    collections: PropTypes.object,
    updateCollections: PropTypes.func,
    isTouch: PropTypes.bool,
    isLoggedIn: PropTypes.bool
};

RecommendedInSc.contextTypes = {
    general: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object
};

export { RecommendedInSc };
export default SafePureComponent(RecommendedInSc);
